/**
 * A tray is a CHANNEL, and that is what separates it from everything else on
 * the sheet. Every other mark here — the architect's walls, dimension lines,
 * service runs, and our own cables — is a single stroke. Nothing else is a
 * bounded lane, so the form says "tray" before the colour has to.
 */
/**
 * Sized for the space the takeoff actually draws in, which is the thing that
 * made the first attempt invisible: the panel passes `circuitStrokeScale` 0.4,
 * so a 14-wide channel arrived on screen 5.6px across with sub-pixel walls —
 * narrower than the white casing of the cable meant to ride inside it.
 *
 * A cable is 8 (3.2 on screen). The lane is about four times that, so a run
 * sits INSIDE it and the relationship is legible rather than implied.
 */
export const TRAY_WIDTH = 34;
export const TRAY_WALL_WIDTH = 3;
/** A wall thinner than a pixel is a wall nobody sees, at any zoom. */
export const TRAY_MIN_WALL_WIDTH = 1;

/**
 * Ink, not a palette hue and not the drawing's grey.
 *
 * `PALETTE` spends twelve colours on circuits, so a coloured tray reads as an
 * eighty-fourth run. Grey was worse: a real architectural sheet is drawn in
 * grey hatching, grey dashed lines and grey text, so grey at any opacity is
 * the colour of architecture and vanishes into it. Value contrast against a
 * pale sheet is what survives.
 */
export const TRAY_WALL_COLOR = "#1e293b";
export const TRAY_HIGHLIGHT_WALL_COLOR = "#0f172a";
export const TRAY_FILL_COLOR = "#334155";

/**
 * The white casing under the walls — the same trick the cable uses, and the
 * only thing that makes an overlay read as ON a drawing rather than part of
 * it. Kept translucent: at full strength it erased the architect's own tray
 * band, which is the thing he is checking ours against.
 */
export const TRAY_CASING_COLOR = "#ffffff";
/**
 * Softer than it first looked right at, because a floor carries a NETWORK of
 * trays, not one: at 0.5 fifteen lanes washed the sheet out into a grey
 * lattice. The walls carry the visibility; the casing only has to separate.
 */
export const TRAY_CASING_OPACITY = 0.38;

export const TRAY_WALL_OPACITY = 0.9;
export const TRAY_FILL_OPACITY = 0.07;

export const TRAY_HIGHLIGHT_WALL_OPACITY = 1;
export const TRAY_HIGHLIGHT_FILL_OPACITY = 0.22;

/** Withdrawn, never hidden: he still has to see the tray he did NOT point at. */
export const TRAY_DIMMED_WALL_OPACITY = 0.25;
export const TRAY_DIMMED_FILL_OPACITY = 0.03;
